import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import {
  AccessDeniedRiComponent,
  AuthorizationRiGuard,
  HomeComponent,
  Permissions,
} from '@r1-development/rps-shared-ui';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: { title: 'Home', showPageHeader: false, redirectTo: '/identification' },
  },
  {
    path: 'access-denied',
    component: AccessDeniedRiComponent,
    canActivate: [AuthGuard],
    data: { title: 'Access Denied', showPageHeader: false },
  },
  {
    path: 'identification',
    loadChildren: () =>
      import('./modules/identification/identification.module').then((mod) => mod.IdentificationModule),
    canActivate: [AuthGuard, AuthorizationRiGuard],
    data: {
      title: 'Rules',
      showPageHeader: true,
      showBreadcrumbs: true,
      breadcrumbs: [{ label: 'Rules', disabled: true }],
      permissions: [Permissions.Rules.Read],
    },
  },
  {
    path: 'client-configuration',
    loadChildren: () =>
      import('./modules/client-configuration/client-configuration.module').then((mod) => mod.ClientConfigurationModule),
    canActivate: [AuthGuard, AuthorizationRiGuard],
    data: {
      title: 'IE Client Configuration',
      showPageHeader: true,
      showBreadcrumbs: true,
      breadcrumbs: [{ label: 'Client Configuration', disabled: true }],
      permissions: [Permissions.Rules.Read],
    },
  },
  {
    path: 'client-dashboard',
    loadChildren: () =>
      import('./modules/client-dashboard/client-dashboard.module').then((mod) => mod.ClientDashboardModule),
    canActivate: [AuthGuard, AuthorizationRiGuard],
    data: {
      title: 'Client Dashboard',
      showPageHeader: true,
      showBreadcrumbs: true,
      breadcrumbs: [{ label: 'Client Dashboard', disabled: true }],
      permissions: [Permissions.Rules.Read],
    },
  },
  { path: 'callback', pathMatch: 'full', redirectTo: '' },
  // Fallback when no prior route is matched
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      //relativeLinkResolution: 'legacy',
      // enableTracing: true, // uncomment for diagnostic tracing
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
